import postRequest from '../../../../../../postRequest';

/**
 * Bulk upload a collections to multiple products.
 *
 * @param {{
 *  referenceIds: string[],
 *  productAttributeDefId: number,
 *  productAttributeLookupOptionId: number[],
 *  languageId: number,
 *  siteId: number,
 *  siteGroupId: number
 * }}
 * @param {string[]} referenceIds Plu Ids
 * @param {number} productAttributeDefId Attribute Id
 * @param {number[]} productAttributeLookupOptionId Lookup Option Id
 * @param {number} languageId Language Id
 * @param {number} siteId Site Id
 * @param {number} siteGroupId Id of the Site Group
*/
export default function postCollectionsPluId({
  referenceIds,
  productAttributeDefId,
  productAttributeLookupOptionId,
  siteId,
  siteGroupId,
  sourceId,
  languageId,
}) {
  const endpoint = `/oc-product-bulkapi/v1/bulk-process/collections/plu-id/${sourceId}`;

  const body = {
    referenceIds,
    productAttributeDefId,
    productAttributeLookupOptionId,
    languageId,
    siteId,
    siteGroupId,
  };

  return new Promise((resolve, reject) => {
    postRequest(endpoint, body, 'Collections (PluId)', 'Started : Collections : PLU (Update)')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}
